import {
  C,
  P0,
  R,
  S,
  abs,
  disc,
  dot,
  fillAt,
  frac,
  lerp,
  max,
  quad,
} from '../../geometry';

export const puff = {
  name: 'Puff',
  colors: ['#12A594', '#E3A008'],
  draw(m, t) {
    let sw = 4 * S(t * 1.2),
      len = 1,
      P = 0,
      lean = 2 * S(t * 0.9),
      pose = P0(),
      wig = 0;
    if (m === 'happy') {
      sw = 14 * S(t * 6);
      len = 1.1;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: seeds keep letting go one by one, drifting off on the wind while a new one grows in.
    if (m === 'thinking') {
      P = 1;
      sw = 6 * S(t * 1.1);
      lean = 4 * S(t * 1.1);
    }
    if (m === 'talking') {
      wig = 1;
    }
    if (m === 'surprised') {
      len = 1.3;
      sw = 0;
    }
    if (m === 'paused') {
      len = 0.65;
      sw = 2 * S(t * 0.6);
      lean = -8;
      pose.ty = 2;
    }
    const hc = [50 + lean * 0.4, 44],
      per = 0.85,
      idx = Math.floor(t / per) % 7,
      f = frac(t / per),
      e = f * f * (3 - 2 * f);
    const A = [-90, -45, 0, 45, 135, 180, 225];
    const rays = [],
      seeds = [];
    A.forEach((a0, i) => {
      const g = P && i === idx ? e : 1,
        a = (a0 + sw) * R,
        l = len * (1 + (wig ? 0.12 * max(0, S(t * 10 - i)) : 0));
      const r1 = lerp(22, 22 + 8 * l, g),
        rd = lerp(22, 22 + 13 * l, g);
      rays.push({
        c: 'b',
        pts: [
          [hc[0] + 22 * C(a), hc[1] + 22 * S(a)],
          [hc[0] + r1 * C(a), hc[1] + r1 * S(a)],
        ],
      });
      seeds.push({
        c: 'b',
        pts: dot(hc[0] + rd * C(a), hc[1] + rd * S(a)),
        o: P ? g : 1,
      });
    });
    const fly = [0, 1].map((k) => {
      const j = (idx - k + 7) % 7,
        ff = (f + k) / 2,
        a = (A[j] + sw) * R,
        sx = hc[0] + (22 + 13 * len) * C(a),
        sy = hc[1] + (22 + 13 * len) * S(a);
      const x = sx + ff * 30 + 3 * S(ff * 9),
        y = sy - ff * 22;
      return {
        c: 'b',
        pts: [
          [x, y],
          [x - 2.5, y + 2.5],
        ],
        o: P * (1 - ff),
        snap: true,
        detail: true,
      };
    });
    const stem = quad([hc[0], 60], [50 + lean * 0.2, 76], [49, 89], 4);
    return {
      strokes: [
        { c: 'b', pts: stem },
        { c: 'a', pts: disc(hc[0], hc[1], 16), n: 24 },
        ...rays,
        ...seeds,
        ...fly,
      ],
      eyes: { x: hc[0], y: hc[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
